import { Component, forwardRef, Inject } from '@angular/core';
import { BlockUI, NgBlockUI }            from 'ng-block-ui';
import { NgbActiveModal }                from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                        from '@angular/forms';
import { TranslateService }              from '@ngx-translate/core';

import { CriticalMessageModel }    from './typings/critical-message';
import { CriticalMessagesService } from './critical-messages.service';
import { MessagesService }         from '../messages.service';

@Component({
  selector   : 'critical-message',
  template: require('./critical-message.component.html')
})
export class CriticalMessageComponent {
  @BlockUI('criticalMessageBlock') block : NgBlockUI;

  message : CriticalMessageModel = {};

  constructor (
    public  activeModal            : NgbActiveModal,
    @Inject(forwardRef(() => CriticalMessagesService))
    private criticalMessagesService: CriticalMessagesService,
    private messagesService        : MessagesService,
    private  translateService      : TranslateService,
  ) {}

  submit ( form : NgForm ) : void {
    this.block.start();

    this.criticalMessagesService.requestCode(this.message)
    .then(( message : CriticalMessageModel ) => {
      this.messagesService.show(this.translateService.instant('GENERAL_SPACE.MESSAGE.VERIFICATION_CODE_SENT'), 'success');

      this.activeModal.close();
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
